import { RateFclFlatRoute } from "./rate-fcl-flat-route.model";
import { LocationMapper } from "../../location/location.mapper";
import { ContainerPrices } from "../../shared/container/container-prices.model";
import { RateMapper } from "../rate.mapper";
import { RateFlatRoute } from "./rate-flat-route.type";
import { rateDiscriminator } from "../rate-discriminator.const";
import { RateAirFlatRoute } from "./rate-air-flat-route.model";
import { RateLclFlatRoute } from "./rate-lcl-flat-route.model";
import { RatePickupDeliveryRoute } from "./rate-ltl-pickup-delivery-route.model";
import { WeightBracketPrices } from "../../shared/weight-bracket/weight-bracket-prices.model";
import { RateLtlRoute } from "./rate-ltl-route.model";
import { RateFclPickupDeliveryRoute } from "./rate-fcl-pickup-delivery-route.model";
import { RateFtlFlatRoute } from "./rate-ftl-route.model";
import { RatePtlFlatRoute } from "./rate-ptl-route.model";

export class RateFlatRouteMapper {
  public static map(data: any): RateFlatRoute {
    if (!data) {
      return null;
    }

    if (data.discriminator === rateDiscriminator.fclFlat) {
      return new RateFclFlatRoute(
        data.id,
        data.discriminator,
        data.rate ? RateMapper.map(data.rate) : null,
        data.originLocation ? LocationMapper.map(data.originLocation) : null,
        data.destinationLocation
          ? LocationMapper.map(data.destinationLocation)
          : null,
        data.currency,
        data.comment,
        data.internalComment,
        new ContainerPrices(data.containers),
      );
    }

    if (data.discriminator === rateDiscriminator.airFlat) {
      return new RateAirFlatRoute(
        data.id,
        data.discriminator,
        data.rate ? RateMapper.map(data.rate) : null,
        data.originLocation ? LocationMapper.map(data.originLocation) : null,
        data.destinationLocation
          ? LocationMapper.map(data.destinationLocation)
          : null,
        data.currency,
        data.comment,
        data.weightPriceLt45,
        data.weightPriceGt45,
        data.weightPriceGt100,
        data.weightPriceGt300,
        data.weightPriceGt500,
        data.weightPriceGt1000,
        data.minPrice,
      );
    }

    if (data.discriminator === rateDiscriminator.ftlFlat) {
      return new RateFtlFlatRoute(
        data.id,
        data.discriminator,
        data.rate ? RateMapper.map(data.rate) : null,
        data.comment,
        data.currency,
        data.originPostalCodeMin,
        data.originPostalCodeMax,
        data.originCountry,
        data.destinationPostalCodeMin,
        data.destinationPostalCodeMax,
        data.destinationCountry,
        data.blPrice,
      );
    }

    if (data.discriminator === rateDiscriminator.ptlFlat) {
      return new RatePtlFlatRoute(
        data.id,
        data.discriminator,
        data.rate ? RateMapper.map(data.rate) : null,
        data.comment,
        data.currency,
        data.originPostalCodeMin,
        data.originPostalCodeMax,
        data.originCountry,
        data.destinationPostalCodeMin,
        data.destinationPostalCodeMax,
        data.destinationCountry,
        data.blPrice,
      );
    }

    if (data.discriminator === rateDiscriminator.lclFlat) {
      return new RateLclFlatRoute(
        data.id,
        data.discriminator,
        data.rate ? RateMapper.map(data.rate) : null,
        data.originLocation ? LocationMapper.map(data.originLocation) : null,
        data.destinationLocation
          ? LocationMapper.map(data.destinationLocation)
          : null,
        data.currency,
        data.comment,
        data.weightPrice,
        data.measurementPrice,
        data.blPrice,
        data.minPrice,
      );
    }

    if (data.discriminator === rateDiscriminator.ltlPickupDelivery) {
      return new RatePickupDeliveryRoute(
        data.id,
        data.discriminator,
        data.rate ? RateMapper.map(data.rate) : null,
        data.zone,
        data.comment,
        data.postalCodeMin,
        data.postalCodeMax,
        data.distanceMin,
        data.distanceMax,
        data.country,
        data.location ? LocationMapper.map(data.location) : null,
        data.transitTime,
        data.serviceDays,
        new WeightBracketPrices(data.weightBrackets),
      );
    }

    if (data.discriminator === rateDiscriminator.fclPickupDelivery) {
      return new RateFclPickupDeliveryRoute(
        data.id,
        data.discriminator,
        data.rate ? RateMapper.map(data.rate) : null,
        data.comment,
        data.postalCodeMin,
        data.postalCodeMax,
        data.distanceMin,
        data.distanceMax,
        data.country,
        data.location ? LocationMapper.map(data.location) : null,
        data.locationName,
        new ContainerPrices(data.containers),
      );
    }

    if (data.discriminator === rateDiscriminator.ltl) {
      return new RateLtlRoute(
        data.id,
        data.discriminator,
        data.rate ? RateMapper.map(data.rate) : null,
        data.comment,
        data.originLocation ? LocationMapper.map(data.originLocation) : null,
        data.destinationLocation
          ? LocationMapper.map(data.destinationLocation)
          : null,
        data.transitTime,
        data.serviceDays,
        new WeightBracketPrices(data.weightBrackets),
      );
    }
  }
}
